import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ProcessSubscriptionService } from '@6grain/masofa-monolith-api-client/common/api/processSubscription.service';
import { ProcessSubscriptionCatalogApplyResult } from '@6grain/masofa-monolith-api-client/common/model/processSubscriptionCatalogApplyResult';
import { ProcessSubscriptionCatalogDocument } from '@6grain/masofa-monolith-api-client/common/model/processSubscriptionCatalogDocument';

export type ProcessSubscriptionCatalogImportResult = ProcessSubscriptionCatalogApplyResult;

@Injectable({ providedIn: 'root' })
export class ProcessSubscriptionCatalogService {
  private readonly api = inject(ProcessSubscriptionService);

  exportCatalog(): Observable<Blob> {
    return this.api.processSubscriptionsExportGet().pipe(
      map(
        (document) =>
          new Blob([JSON.stringify(document)], { type: 'application/json' }),
      ),
    );
  }

  importCatalog(document: unknown): Observable<ProcessSubscriptionCatalogImportResult> {
    return this.api.processSubscriptionsImportPost(document as ProcessSubscriptionCatalogDocument);
  }
}
